import type { DevicePaymentMethod } from "../../../../api/devices";

// Валидация на payment methods за устройство — извиква се преди submit.
export const validateDevicePaymentMethods = (
  items: DevicePaymentMethod[],
): "values" | "duplicateMethods" | null => {
  if (items.some((i) => typeof i.value !== "string" || i.value.trim() === "")) {
    return "values";
  }
  const ids = items.map((i) => i.paymentMethodId);
  if (new Set(ids).size !== ids.length) return "duplicateMethods";
  return null;
};
